<template>
  <div class="subprograms-list">
    <div
      v-masonry
      transition-duration="0"
      item-selector=".subprograms-list__element"
      :gutter="40"
      :horizontal-order="true"
    >
      <div
        v-masonry-tile
        class="subprograms-list__element"
        v-for="(subprogram, i) in subprograms"
        :key="`subprograms-list__subprogram--${subprogram.name}--${i}`"
      >
        <subprogram-element :subprogram="subprogram" />
      </div>
    </div>
  </div>
</template>

<script>
import SubprogramElement from '@/components/SubprogramElement.vue'

export default {
  name: 'subprograms-list',
  props: {
    subprograms: {
      type: Array,
      default: () => ([]),
    }
  },
  components: {
    SubprogramElement,
  },
}
</script>

<style lang="scss" scoped>
.subprograms-list {
  background-color: #f7f7f7;
  padding: 0 30px 40px;

  @include mobile {
    padding: 0 16px 24px;
  }

  @include tablet {
    padding: 0 50px 40px;
  }

  .grid-sizer,
  &__element {
    width: 30%;

    @include mobile {
      width: 100%;
    }

    @include tablet {
      width: 100%;
    }

    @include desktop {
      width: 45%;
    }
  }
}
</style>
